import { render, staticRenderFns } from "./Colores.vue?vue&type=template&id=7478b4b5"
import script from "./Colores.vue?vue&type=script&lang=js"
export * from "./Colores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports